import React, { PureComponent } from "react";
import styled from "styled-components";

const UserUl = styled.ul`
  display: block;
  width: ${(props) => props.width || "33.33%"};
  padding: ${(props) => props.padding || "0 40px"};
  box-sizing: border-box;
`;
const UserOnlyText = styled.li`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "18px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  line-height: 26px;
  ${({ theme }) => theme.media.mobile`
    line-height: 15px;
  font-size: 10px
    `}
`;
const UserSpan = styled.span`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "0px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  margin: ${(props) => props.margin || "inherit"};
  position: ${(props) => props.position || "static"};
  ${({ theme }) => theme.media.mobile`
  font-size: 10px
    `}
`;

export class PersonalAgreement1 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제1조 개인정보 처리 항목
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 다양한 서비스 제공을 위하여, 적법한 수단을 통하여 아래와 같은
            회원 정보를 수집하고 있습니다. 만 14세 미만 아동은 회원가입이
            불가능합니다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                회원 수집 항목
                <UserUl>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    휴대폰번호, 이메일 주소, 이름, 생년월일, 성별
                  </UserOnlyText>
                </UserUl>
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                가맹점 수집 항목
                <UserUl>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    필수정보 : 사업자 등록번호, 매장 이름, 대표자명,
                    연락처(유선/무선), 매장 주소
                  </UserOnlyText>
                </UserUl>
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            서비스 이용 과정에서 IP주소, 쿠키, 서비스 이용 기록, 기기정보,
            위치정보가 생성되어 수집될 수 있습니다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}
export class PersonalAgreement2 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제2조 개인정보 수집·이용 및 목적
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            회사는 서비스를 위한 목적에 필요한 범위에서 최소한의 개인정보를 수집
            및 이용합니다. 수집한 개인정보는 다음의 목적 외 용도로는 이용되지
            않으며, 이용 목적이 변경될 경우 회원의 사전 동의를 구합니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회원 수집 목적
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                서비스 제공에 관한 계약 이행, 컨텐츠 제공, 특정 맞춤 서비스 제공
                등 발송, 본인인증
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                회원제 서비스 이용 및 제한적 본인 확인제에 따른 본인확인,
                개인식별, 불량회원의 부정 이용 방지, 비인가 사용방지, 가입의사
                확인, 가입 및 가입횟수 제한, 추후 법정 대리인 본인확인, 분쟁
                조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른
                서비스 제공 및 광고 게제, 서비스의 유효성 확인, 이벤트 및 광고성
                정보 제공 및 참여기회 제공, 접속빈도 파악, 회원의 서비스 이용에
                대한 통계, 회원제 서비스 이용에 따른 본인확인, 개인식별,
                불량회원의 부정 이용 방지와 비인가 사용방지, 가입 의사 확인,
                불만처리 등 민원처리, 고지사항 전달
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            가맹점 수집 목적
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                랩포인트 서비스 사용을 위한 전산등록
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class PersonalAgreement3 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제3조 개인정보의 제공 및 위탁
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 회원의 동의, 법률의 특별한 규정 등 개인정보보호법제17조 및
            제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. 회원이
            회사에서 제공하는 서비스를 이용하기 위하여 제3자에 개인정보를
            제공하는 목록은 다음과 같으며, 아래 서비스를 이용하지 않는 회원의
            개인정보는 제3자에 제공되지 않습니다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                제공 받는 자 : 서비스 가맹점 또는 브랜드
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                제공 목적 : 브랜드 멤버십 혜택 및 이벤트를 진행하기 위하여
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                제공 정보 : 전화번호, 서비스 이용기록, 생일, 성별, 이름
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  d.
                </UserSpan>
                보유 및 이용기간 : 서비스 해지 시점 후 3개월
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  e.
                </UserSpan>
                서비스의 개인정보를 제공 받는 자는 1) 이용자 방문 가맹점 및 2)
                이용자가 제3자 정보 제공에 동의한 가맹점에 한정되며, 그러한
                가맹점의 변동에 따른 개인정보취급방침의 수시개정이 어려워
                가맹점을 페이지 링크로 명시합니다.
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 원활한 서비스 제공을 위하여 다음과 같이 개인정보 처리업무를
            위탁하고 있으며, 회사가 수탁업체에 위탁하는 업무와 관련된 서비스를
            이용하지 않는 회원의 개인정보는 수탁업체에 제공되지 않습니다. 회사는
            위탁계약 시 개인정보보호법제26조에 따라 위탁업무 수행목적 외
            개인정보 처리금지, 기술적·관리적 보호조치 및 책임부담 등이 명확히
            규정된 문서에 따라 처리하고 있습니다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                수탁업체 : (주)누리고
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                위탁업무내용 : 회원가입 인증, 서비스 공지사항, 또는 문자 쿠폰
                전송 시 SMS, LMS, MMS 등의 문자를 전송
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                취급 정보 : 휴대전화번호
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  d.
                </UserSpan>
                보유기간 : 회원 탈퇴 또는 위탁관리 계약 종료시까지
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            회사는 본 조의 개인정보의 제3자 제공 및 위탁업무의 내용이 변경될
            경우에는 지체 없이 개인정보처리방침을 통하여 고지하겠습니다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class PersonalAgreement4 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제4조 개인정보의 보유 및 파기
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이
            달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의
            이유로 명시한 기간 동안 보존합니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 원칙적으로 회원의 개인정보를 회원 탈퇴 시까지 보유하며, 회원
            탈퇴 시 지체없이 파기합니다. 단, 이용자에게 개인정보 보관기간에 대해
            별도의 동의를 얻은 경우, 또는 법령에서 일정 기간 정보보관 의무를
            부과하는 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                전자상거래 등에서 소비자 보호에 관한 법률
                <UserUl>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    표시·광고에 관한 기록 : 6개월
                  </UserOnlyText>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    계약 또는 청약철회 등에 관한 기록 : 5년 보관
                  </UserOnlyText>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    대금결제 및 재화 등의 공급에 관한 기록 : 5년 보관
                  </UserOnlyText>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 보관
                  </UserOnlyText>
                </UserUl>
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                전자금융거래법
                <UserUl>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    전자금융에 관한 기록 : 5년 보관
                  </UserOnlyText>
                </UserUl>
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                통신비밀보호법
                <UserUl>
                  <UserOnlyText>
                    <UserSpan margin="0 12px 0 -25px" position="absolute">
                      ·
                    </UserSpan>
                    로그인 기록 등 방문 기록 : 3개월
                  </UserOnlyText>
                </UserUl>
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회원탈퇴, 서비스 종료, 이용자에게 동의 받은 개인정보 보유기간의
            도래와 같이 개인정보의 수집 및 이용목적이 달성된 개인정보는 재생이
            불가능한 방법으로 파기합니다. 법령에서 보존의무를 부과한 정보는 해당
            법령에서 정한 기간이 경과한 후 지체없이 재생이 불가능한 방법으로
            파기합니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            회사는 ‘개인정보 유효기간제’에 따라 1년 간 로그인하지 않거나
            서비스를 이용하지 않은 회원의 개인정보를 별도로 분리하여 보관 및
            관리합니다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class PersonalAgreement5 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제5조 정보주체 및 법정대리인의 권리와 행사 방법
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회원은 언제든지 '더보기 내정보'에서 자신의 개인정보를 조회하거나
            수정·삭제할 수 있으며, 서면, 전자우편 등의 방법으로 개인정보 열람을
            요청할 수 있습니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            제1항에 따른 권리 행사는 회원의 법정대리인이나 위임을 받은 자 등
            대리인을 통하여 하실 수 있습니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            이용자는 언제든지 개인정보 처리의 정지를 요청할 수 있으며, 법률에
            특별한 규정이 있는 등의 경우에는 처리정지 요청을 거부할 수 있습니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            이용자는 언제든지 ‘회원탈퇴’ 등을 통해 개인정보의 수집 및 이용
            동의를 철회할 수 있습니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            회원이 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기
            전까지 해당 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된
            개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게
            지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            개인정보 열람 및 처리정지 요구는 개인정보 보호법 제37조제2항 및 관련
            법령에 의하여 회원의 권리가 제한될 수 있습니다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class PersonalAgreement6 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제6조 개인정보의 안정성 확보조치
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            회사는 개인정보를 안전하게 관리하기 위하여 최선을 다하며 다음과 같은
            조치를 취하고 있습니다.
            <UserUl>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                관리적 조치 : 내부관리계획 수립·시행
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                물리적 조치 : 개인정보시스템의 물리적 보관 장소에 대한 비인가자
                출입 통제
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                기술적 조치 : 개인정보에 대한 접근 제한, 중요정보에 대한 암호화,
                보안프로그램 설치 등
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class PersonalAgreement7 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제7조 개인정보 처리책임자
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            회사는 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을
            위하여 아래와 같이 개인정보 처리책임자를 지정하고 있습니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            개인정보 보호책임자
            <UserUl>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                이름 : 이아영
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                소속 : 랩포인트
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                직위 : 대표
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                연락처 : jenny@lab254.com
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            개인정보 보호담당자
            <UserUl>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                이름 : 김도연
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                소속 : 랩포인트
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                직위 : CTO
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                연락처 : doyon@lab254.com
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에
            문의하시기 바랍니다.
            <UserUl>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                한국 인터넷진흥원(privacy.kisa.or.kr / 02-405-5118)
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                개인분쟁조정위원회(www.1336.or.kr / 1336)
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                대검찰청 인터넷범죄수사센터(http://icic.sppo.go.kr /
                02-3480-3600)
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                경찰청 사이버테러 대응센터(www.ctrc.go.kr / 02-392-0330)
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class PersonalAgreement8 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제8조 개인정보처리방침 적용범위
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            본 개인정보처리방침은 회사가 제공하는 제반 서비스에 적용됩니다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사가 제공하는 부가적 서비스 중 별도의 회원가입이 필요한 서비스 및
            회사의 앱에 링크되어 있는 제휴 사이트 이용자의 개인정보를 수집하는
            행위에 대해서는 본 개인정보 처리방침이 적용되지 않습니다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class PersonalAgreement9 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제9조 개정 전 고지의무
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            본 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 경우 최소 7일
            전에 ‘공지사항’을 통해 사전 공지하겠습니다. 다만, 수집하는
            개인정보의 항목, 이용목적의 변경 등과 같이 이용자 권리의 중대한
            변경이 발생할 때에는 최소 30일 전에 공지하며, 필요 시 이용자 동의를
            다시 받을 수도 있습니다.
            <UserUl>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                공고일자 : 2021년 8월 25일
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  ·
                </UserSpan>
                실행일자 : 2021년 8월 25일
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}
